import { render, staticRenderFns } from "./AccumulatedProfit.vue?vue&type=template&id=09093637"
import script from "./AccumulatedProfit.vue?vue&type=script&lang=js"
export * from "./AccumulatedProfit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports